export class User {
	public id: string;
	public username: string;
}
